import type { ITableCell } from "../types";
import {
  evaluateCalculation,
  rawCalculationResult,
} from "./evaluate-calculation";

// Raw (locale-independent) calc result for sort/filter KEYING. Returns
// undefined for non-calc cells so callers keep their existing raw-text path.
// Uses the raw result, not the localized display string, so numeric comparison
// and parseSortableValue round-tripping stay correct. rowOrder is intentionally
// omitted (unlike the render path) so the value is table-wide.
export const calcCellText = (
  cell: ITableCell | undefined,
  tableData: ITableCell[],
  tableCols: number,
  tableRows: number,
  col: number,
  row: number,
): string | undefined => {
  if (!cell?.calculation) return undefined;
  const result = evaluateCalculation(cell.calculation.formula, {
    tableData,
    tableCols,
    tableRows,
    cellCoord: { col, row },
  });
  return rawCalculationResult(result);
};
